(() => {
  if (window.pdpRectangleSizingInstalled) return;
  window.pdpRectangleSizingInstalled = true;
  const selector = 'variant-selects.pdp-selector-controls';
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  let frame = 0;
  let measuring = false;
  const number = (value, fallback = 0) => {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  function update(root) {
    root.removeAttribute('data-pdp-auto-rectangles');
    const rootStyle = getComputedStyle(root);
    const rootWidth = number(rootStyle.width);
    const rootScale = rootWidth > 0 ? root.getBoundingClientRect().width / rootWidth : 1;
    if (!(rootScale > 0)) return;
    const labels = Array.from(root.querySelectorAll('.pdp-choice:not([data-pdp-piece="color"]) input[type="radio"] + label[data-pdp-compact="false"]'));
    if (!labels.length) return;
    const reference = labels.find(label => label.closest('[data-pdp-piece="fit"]') && label.previousElementSibling.value.toLowerCase() === 'standard')
      || labels.find(label => label.previousElementSibling.value.toLowerCase() === 'standard');
    let padding;
    if (reference) {
      const text = reference.querySelector('.pdp-option-text');
      if (text) {
        const boxStyle = getComputedStyle(reference);
        const cssWidth = number(boxStyle.width);
        const boxWidth = reference.getBoundingClientRect().width;
        const totalScale = cssWidth > 0 ? boxWidth / cssWidth : rootScale;
        const borders = number(boxStyle.borderLeftWidth) + number(boxStyle.borderRightWidth);
        const textWidth = text.getBoundingClientRect().width / totalScale;
        const localPadding = (cssWidth - textWidth - borders) / 2;
        padding = localPadding * totalScale / rootScale;
      }
    }
    if (!Number.isFinite(padding)) {
      if (!context) return;
      const family = rootStyle.getPropertyValue('--pdp-reference-font-family').trim() || rootStyle.fontFamily;
      const fontSize = number(rootStyle.getPropertyValue('--pdp-reference-font-size'), 14.24);
      const weight = rootStyle.getPropertyValue('--pdp-reference-font-weight').trim() || '400';
      const fontStyle = rootStyle.getPropertyValue('--pdp-reference-font-style').trim() || 'normal';
      const rowScale = number(rootStyle.getPropertyValue('--pdp-reference-row-scale'), 1);
      const referenceWidth = number(rootStyle.getPropertyValue('--pdp-reference-box-width'), 85.6);
      const border = number(rootStyle.getPropertyValue('--pdp-reference-border-width'), 1);
      context.font = `${fontStyle} ${weight} ${fontSize}px ${family}`;
      const spacing = number(rootStyle.letterSpacing);
      const standardWidth = context.measureText('Standard').width + spacing * 8;
      padding = (referenceWidth - standardWidth - border * 2) / 2 * rowScale;
    }
    root.style.setProperty('--pdp-rectangle-padding', `${Math.max(0, padding)}px`);
    root.setAttribute('data-pdp-auto-rectangles', '');
  }
  function updateAll() {
    if (measuring) return;
    measuring = true;
    try { document.querySelectorAll(selector).forEach(update); }
    finally { measuring = false; }
  }
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { frame = 0; updateAll(); });
  }
  function start() {
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
    fontsReady.then(schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:block:select', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    if (document.fonts) document.fonts.addEventListener('loadingdone', schedule);
    const observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'characterData'
        ? record.target.parentElement?.closest(selector)
        : Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector)))
          || record.target.closest?.(selector))) schedule();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(() => {
  if (window.pdpMobilePaymentSizingInstalled) return;
  window.pdpMobilePaymentSizingInstalled = true;
  const mobile = window.matchMedia('(max-width: 770px)');
  let frame = 0;
  function fitRows() {
    document.querySelectorAll('.pdp-reference-panel .pdp-payment-row').forEach(row => {
      row.style.removeProperty('transform');
      row.style.removeProperty('transform-origin');
      if (!mobile.matches) return;
      const panel = row.closest('.pdp-reference-panel');
      const rowBounds = row.getBoundingClientRect();
      const panelBounds = panel.getBoundingClientRect();
      const cssWidth = parseFloat(getComputedStyle(row).width);
      const parentScale = cssWidth > 0 ? rowBounds.width / cssWidth : 1;
      if (!(parentScale > 0)) return;
      const children = Array.from(row.children).map(child => child.getBoundingClientRect()).filter(bounds => bounds.width > 0);
      if (!children.length) return;
      const left = Math.min(rowBounds.left, ...children.map(bounds => bounds.left));
      const right = Math.max(...children.map(bounds => bounds.right));
      const targetLeft = Math.max(panelBounds.left, rowBounds.left);
      const available = panelBounds.right - targetLeft;
      const extent = right - left;
      if (!(available > 0 && extent > 0)) return;
      const scale = Math.min(1, available / extent);
      const shift = (targetLeft - rowBounds.left - (left - rowBounds.left) * scale) / parentScale;
      if (scale < 0.9999 || Math.abs(shift) > 0.01) {
        row.style.transformOrigin = 'left top';
        row.style.transform = `translateX(${shift}px) scale(${scale})`;
      }
    });
  }
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { frame = 0; fitRows(); });
  }
  function start() {
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(schedule);
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('load', event => {
      if (event.target.matches?.('.pdp-payment-row img')) schedule();
    }, true);
    if (document.fonts) document.fonts.addEventListener('loadingdone', schedule);
    const observer = new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.pdp-payment-row') || node.querySelector?.('.pdp-payment-row'))))) schedule();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

